import React from "react";
import { PlayerPin } from "./player-pin";
import styles from "./position-slot.module.css";

export function PositionSlot(props) {
  const { pos, players, headshotMap = {}, interactive = true } = props;

  return (
    <div className={styles.slot}>
      <div className={styles.label}>{pos}</div>
      {players.length === 0 ? (
        <div className={styles.empty} />
      ) : (
        players.slice(0, 3).map((player, i) => (
          <PlayerPin
            key={player.id}
            player={player}
            headshotUrl={headshotMap[player.id]}
            isStarter={i === 0}
            interactive={interactive}
          />
        ))
      )}
    </div>
  );
}
